<template>
  <div class="block1200 block1620 ck-content submit-cont">
    <a-row :gutter="[16, 16]">
      <a-col :span="18">
        <a-card :title="false" style="min-height: 888px;">
          <a-form
            :colon="false"
            id="check"
            :form="form"
            v-bind="formItemLayout"
          >
            <div class="level-verisons" style="display: block">
              <div
                v-on:click="$store.commit('check/changeKey', item)"
                :class="
                  $store.state.check.activeKey === item.userProductCode
                    ? 'version-item active'
                    : 'version-item'
                "
                v-for="item in $store.state.check.userProduct.userProducts"
                :key="item.userProductCode"
              >
                <div class="v-name">
                  {{ item.productName }}
                  <div v-if="item.unitType === 'NUM'">
                    {{ item.userPrice }}元 / {{ item.unit }}字
                  </div>
                  <div v-else>{{ item.userPrice }}元 / 篇</div>
                </div>
                <div class="v-foot">{{ item.productTypeName }}</div>
                <img
                  src="../assets/images/icon-check-rt.png"
                  class="icon-check"
                />
              </div>
              <div class="clear"></div>
            </div>
            <div style="margin-bottom: 20px">
              <a-icon
                type="exclamation-circle"
                style="color: red; font-size: 18px; margin-right: 10px"
              />系统支持中文检测
            </div>
            <a-input
              v-decorator="[
                'checkType',
                { initialValue: $store.state.check.activeKey },
              ]"
              type="hidden"
            />
            <a-form-item label="题目">
              <a-input
                placeholder="最多输入50个字"
                :maxLength="50"
                v-decorator="[
                  'title',
                  {
                    rules: [
                      { required: true, message: '请输入题目!' },
                      { validator: this.checkSpecialInput }
                    ],
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="作者">
              <a-input
                placeholder="多个作者请用逗号隔开，最多输入15个字"
                :maxLength="15"
                v-decorator="[
                  'author',
                  {
                    initialValue:$route.query.author || '',
                    rules: [{ required: true, message: '请输入作者!' },
                     { validator: this.checkSpecialInput }
                    ],
                  },
                ]"
              />
            </a-form-item>
            <ARow>
              <ACol :span="8">
                <a-form-item label="学位" v-bind="formItemLayout1">
                  <DictSelect
                    placeholder="请选择文件类型"
                    code="degree"
                    v-decorator="['degree']"
                  />
                </a-form-item>
              </ACol>
              <ACol :span="8">
                <a-form-item label="专业" v-bind="formItemLayout1">
                  <DictSelect
                    placeholder="请选择学科专业"
                    code="major"
                    v-decorator="['major']"
                  />
                </a-form-item>
              </ACol>
              <ACol :span="8">
                <a-form-item label="学校" v-bind="formItemLayout1">
                  <DictAuto
                    placeholder="可直接输入或下拉选择"
                    code="school"
                    v-decorator="['school']"
                  />
                </a-form-item>
              </ACol>
            </ARow>
            <ARow v-if="$store.state.check.activeObj.productType === 'PA'">
              <!--              <ACol :span="12">-->
              <!--                <a-form-item label="来源" v-bind="formItemLayout2">-->
              <!--                  <DictSelect code="source" v-decorator="['source']" />-->
              <!--                </a-form-item>-->
              <!--              </ACol>-->
              <ACol :span="24">
                <a-form-item label="收稿日期" v-bind="formItemLayout2">
                  <a-date-picker
                    placeholder=""
                    v-decorator="[
                      'publishdate',
                      {
                        rules: [{ required: true, message: '请输入收稿日期!' }],
                      },
                    ]"
                    style="width: 100%"
                  />
                  <a-alert class="alert" message="请正确填写已发表文献的收稿日期，否则不能正确排除已发表文献。" banner />
                </a-form-item>
              </ACol>
            </ARow>
            <a-form-item label="方式">
              <a-tabs type="card" @change="callback">
                <a-tab-pane key="1" tab="上传文档">
                  <a-form-item>
                    <a-upload
                      :action="'/thesisCheck/api/file/upload'"
                      name="file"
                      :file-list="fileList"
                      @change="handleChange"
                      :before-upload="beforeUpload"
                    >
                      <a-button type="primary">
                        <a-icon type="upload" /> 选择文件
                      </a-button>
                    </a-upload>
                  </a-form-item>
                  <div class="attention">
                    <div class="tit">注意事项:</div>
                    <p>
                      1.系统直通检测官网，是从官方下载的报告，支持所有报告验真，若有假冒，全额退款。如有任何的疑问可联系客服解决。
                    </p>
                    <p>
                      2.文档大小请不要超过
                      <span class="imp">30M</span
                      >，否则将无法上传。可将论文中的图片删除（系统不检测图片）。
                    </p>
                    <p>
                      3.支持文档格式：WORD文件（.doc .docx）、文本文件（.txt）
                    </p>
                  </div>
                </a-tab-pane>
                <a-tab-pane key="2" tab="粘贴上传">
                  <a-textarea
                    v-decorator="['content']"
                    :placeholder="`填写需要检测内容，字数限制大于500字，小于${$store.state.check.activeObj.maxNum}字，提交内容建议去除封面、目录，仅提交正文`"
                    :auto-size="{ minRows: 10, maxRows: 10 }"
                    @change="contTextNum"
                  />
                </a-tab-pane>
                <span slot="tabBarExtraContent" v-if="tabKey === '1'">
                  计费方式:
                  <span v-if="$store.state.check.activeObj.unitType === 'NUM'"
                    >{{ $store.state.check.activeObj.userPrice }}元 /{{
                      $store.state.check.activeObj.unit
                    }}字, 当前已输入 {{ fileCount }} 字符</span
                  >
                  <span v-else
                    >{{ $store.state.check.activeObj.userPrice }}元 /篇,
                    当前已输入 {{ fileCount }} 字符</span
                  >
                </span>
                <span slot="tabBarExtraContent" v-if="tabKey === '2'">
                  计费方式:
                  <span v-if="$store.state.check.activeObj.unitType === 'NUM'"
                    >{{ $store.state.check.activeObj.userPrice }}元 /{{
                      $store.state.check.activeObj.unit
                    }}字, 当前已输入 {{ fileCount1 }} 字符</span
                  >
                  <span v-else
                    >{{ $store.state.check.activeObj.userPrice }}元 /篇,
                    当前已输入 {{ fileCount1 }} 字符</span
                  >
                </span>
              </a-tabs>
            </a-form-item>
            <a-form-item
              :label-col="formTailLayout.labelCol"
              :wrapper-col="formTailLayout.wrapperCol"
            >
              <a-button type="primary" @click="next"> 下一步 </a-button>
            </a-form-item>
          </a-form>
        </a-card>
      </a-col>
      <a-col :span="6" style="min-height: 715px" id="sider">
        <a-card>
          <div class="titler" slot="title"><a-icon type="slack" />检测范围</div>
          <ul class="cb-list">
            <!-- <li><i class="igou"></i>中国学术期刊数据库</li>
            <li><i class="igou"></i>中国学位论文全文数据库</li>
            <li><i class="igou"></i>中国学术会议论文数据库</li>
            <li><i class="igou"></i>中国学术网页数据库</li>
            <li><i class="igou"></i>中国专利文献数据库</li>
            <li><i class="igou"></i>中国优秀报纸数据库</li> -->
            <!-- <li title=""><i class="igou"></i>
              <a-tooltip placement="topLeft" title="含中国学术期刊数据库、优先出版论文数据库" :get-popup-container="getPopupContainer">
                期刊论文数据库
              </a-tooltip>
            </li> -->
            <!-- <li title="含中国学术期刊数据库、优先出版论文数据库"><i class="igou"></i>期刊论文数据库</li>
            <li title="含中国博士学位论文全文数据库、中国优秀硕士学位论文全文数据库"><i class="igou"></i>学位论文数据库</li>
            <li><i class="igou"></i>国内外重要学术会议论文数据库</li>
            <li title="含互联网学术资源数据库、学术网络文献数据库"><i class="igou"></i>网文数据库</li>
            <li><i class="igou"></i>中国专利文献全文数据库</li>
            <li><i class="igou"></i>中国优秀报纸全文数据库</li>
            <li><i class="igou"></i>特色英文文摘数据库</li>
            <li><i class="igou"></i>中国标准全文数据库</li> -->
            
            <li><i class="igou"></i>中国学术期刊数据库</li>
            <li><i class="igou"></i>中国标准全文数据库</li>
            <li><i class="igou"></i>中国优秀报纸全文数据库</li>
            <li><i class="igou"></i>中国专利文献全文数据库</li>
            <li><i class="igou"></i>中国博士学位论文全文数据库</li>
            <li><i class="igou"></i>中国优秀硕士学位论文全文数据</li>
            <li><i class="igou"></i>国内外重要学术会议论文数据库</li>
            <li><i class="igou"></i>优先出版论文数据库</li>
            <li><i class="igou"></i>互联网学术资源数据库</li>
            <li><i class="igou"></i>学术网络文献数据库</li>
            <li><i class="igou"></i>特色英文文摘数据库</li>
        
          </ul>
        </a-card>
        <a-card style="margin-top: 20px;min-height: 437px;">
          <div class="titler" slot="title"><a-icon type="heart" />常见问题</div>
          <ul class="as_list">
            <li>
              <p>1.系统检测支持什么语种？</p>
              <p class="p2">回答：系统支持中文文献相似性检测。</p>
            </li>
            <li>
              <p>2.系统可以检测哪些类别的文章？</p>
              <p class="p2">
                回答：万方检测-可检测涵盖所有中文类别，包括哲学、经济学、管理学、法学、社会科学、教育学、文学、艺术学、历史学、理学、工学、农学、医学、政治学、军事学等学科论文。
              </p>
            </li>
            <li>
              <p>3.如何正确标识参考文献？</p>
              <p class="p2">
                参考文献位于文章尾部，以“参考文献”四个单字单独成行，后面跟随标准的参考文献格式即可。
              </p>
            </li>
          </ul>
          <!-- <div class="service_div" style="margin-top: 20px">
            <div style="display: inline-block;">
            <a
              :href="$store.state.check.userProduct.qrCodeUrlPath"
              target="_blank"
              title="点击跳转客服链接"
            > -->
              <!-- <img src="../assets/images/wf2code.png" width="120" alt="" style="float: left;margin-right: 5px;"> -->
              <!-- <img
                :src="$store.state.check.qrUrl"
                width="120"
                alt=""
                style="margin-right: 5px;"
              />
            </a> -->
            <!-- </div> -->
            <!-- <div
              style="
                display: table;
                line-height: 2em;
                font-size: 12px;
                height: 120px;
                width: 148px;
              "
            > -->
            <!-- <div
              style="
                display: inline-block;
                line-height: 2em;
                font-size: 10px;
                /* height: 120px; */
                width: 148px;
                vertical-align: middle;
              "
            >
              <p v-if="$store.state.check.userProduct.serviceNote"
              style="position: absolute;
                  top: 12px;
                  line-height: 16px;
                  padding-right: 10px;
                "
              >
                {{ $store.state.check.userProduct.serviceNote }} -->
                  <!-- 扫码关注万方小书童，点击咨询  -->
              <!-- </p> -->
              <!-- <p style="position: absolute;">我是万小方，点我咨询哦！！！</p> -->
              <!-- <div
                style="
                  width: 100%;
                  height: 100%;
                  vertical-align: bottom;
                  margin-top: 60px;
                "
              >
                <p v-if="$store.state.check.userProduct.serviceQq">
                  QQ:&nbsp;{{ $store.state.check.userProduct.serviceQq }}
                </p>
                <p v-if="$store.state.check.userProduct.serviceContact">
                  电话:&nbsp;{{ $store.state.check.userProduct.serviceContact }}
                </p>
                <p v-if="$store.state.check.userProduct.serviceMail">
                  邮箱:&nbsp;{{ $store.state.check.userProduct.serviceMail }}
                </p> -->
                <!-- <span>微信扫一扫</span><span style="margin-left:10px">咨询在线客服</span> -->

                <!-- <p>QQ:&nbsp;123456789</p>
                <p>电话:&nbsp;123456789</p>  -->
                <!-- <p>邮箱:&nbsp;check@wanfangtech.com</p> -->
              <!-- </div>
            </div>
          </div> -->
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { Row, Col, Card, Icon, Form, Input, Tabs, Button, Upload, DatePicker, Alert  } from 'ant-design-vue'
import DictSelect from "@/components/DictSelect";
import DictAuto from "@/components/DictAuto";
import moment from 'moment'
const getType = (file) =>{
            var filename=file;
            var index1=filename.lastIndexOf(".");
            var index2=filename.length;
            var type=filename.substring(index1,index2);
            return type.toUpperCase();
        }
export default {
  components: {
    ARow: Row,
    ACol: Col,
    ACard: Card,
    AIcon: Icon,
    AForm: Form,
    AFormItem: Form.Item,
    AInput: Input,
    ATextarea: Input.TextArea,
    ATabs: Tabs,
    ATabPane: Tabs.TabPane,
    AButton: Button,
    AUpload: Upload,
    ADatePicker: DatePicker,
    DictSelect,
    DictAuto,
    AAlert:Alert
    // ATooltip:Tooltip
  },
  data: () => ({
    formItemLayout: {
      labelCol: { span: 2 },
      wrapperCol: { span: 22 },
    },
    formItemLayout1: {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    },
    formItemLayout2: {
      labelCol: { span: 2 },
      wrapperCol: { span: 20 },
    },
    formTailLayout: {
      labelCol: { span: 2 },
      wrapperCol: { span: 8, offset: 2 },
    },
    tabKey: '1',
    fileList: [],
    fileCount: 0,
    fileCount1: 0,
  }),
  beforeCreate () {
    console.log(this.$route)
    debugger
    this.form = this.$form.createForm(this, { name: 'wfContent' });
  },
  created () {
    this.$store.dispatch('check/getQRcodeUrl')
  },
  methods: {

    checkSpecialInput (rule, value, callback) {
      const specialInput = new RegExp('[*]')
      const blankInput = /\s/g
      const pointInput = /\./g
      if (specialInput.test(value)) {
        callback(new Error("不能包含符号'*'"))
      }
      if(value.match(blankInput)){
        callback(new Error("不能包含空格符"))
      }
      if(value.match(pointInput)){
        callback(new Error("不能包含符号'.'"))
      }
       callback()
    },

    getPopupContainer(trigger) {
      return trigger.parentElement;
    },

    callback (key) {
      this.tabKey = key
    },
    handleChange (info) {
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      fileList = fileList.map(file => {
        if (file.status === 'uploading') {
          return file
        }
        if (file.status === 'done' && file.response && file.response.data) {
          const values = this.form.getFieldsValue()
          if (!values.title) {
            this.form.setFieldsValue({
              title: file.response.data.fileName.substring(0, 50),
            });
          }
          this.fileCount = file.response.data.wordNumber
          return {
            ...file,
            ...file.response.data
          };
        }
      });
      this.fileList = fileList[0] && fileList || []
    },
    beforeUpload (file) {
      const filetype = getType(file.name)   
      const isJpgOrPng = (filetype === '.DOC' || filetype === '.DOCX' || filetype === '.TXT')
      // const isJpgOrPng = file.type === 'text/plain' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type === 'application/msword' || file.type === 'application/pdf';
      if (!isJpgOrPng) {
        this.$message.error('支持文档格式：WORD文件（.doc .docx）、文本文件（.txt）');
      }
      const isLt2M = file.size / 1024 / 1024 < 30;
      if (!isLt2M) {
        this.$message.error('文件不能大于 30MB!');
      }
      return isJpgOrPng && isLt2M;
    },
    contTextNum (e) {
      let str = e.target.value
      // //去掉回车换行符
      str = str.replace(/\n+/g, "");
      this.fileCount1 = str.length
    },
    next () {
      this.form.validateFields((err, values) => {
        if (err) {
          return;
        }
        if (values.publishdate) {
          values.publishdate = moment(values.publishdate).format('YYYY-MM-DD')
        }
        if (this.tabKey === '1') {
          const fileList = this.fileList
          if (!fileList.length) {
            this.$message.error('请选择论文')
            return
          }
          this.$store.dispatch('check/creatTrade', {
            payload: {
              ...values,
              ...fileList[0],
              type: this.$store.state.check.activeObj.userProductCode,
            },
            callback: (res) => {
              if (res.error_code === '10000') {
                this.$router.push(`/payform/${res.result.tradeId}`)
              }
            }
          })
        } else {
          const fileCount = this.fileCount1
          let bigSize = 300000
          if (this.$store.state.check.activeObj.maxNum) {
            bigSize = this.$store.state.check.activeObj.maxNum
          }
          // console.log(bigSize)
          if (fileCount < 500 || fileCount > bigSize) {
            this.$message.error(`填写需要检测内容，字数限制大于500字，小于${bigSize}字`)
            return
          }
          this.$store.dispatch('check/creatTrade', {
            payload: {
              ...values,
              type: this.$store.state.check.activeObj.userProductCode
            },
            callback: (res) => {
              if (res.error_code === '10000') {
                this.$router.push(`/payform/${res.result.tradeId}`)
              }
            }
          })
        }
      });
    }
  }
};
</script>

<style scoped>
.alert{
    width: 400px;
    font-size: 12px;
    padding: 3px 0 3px 20px;
}
.alert /deep/ .ant-alert-icon {
    position: absolute;
    top: 6px;
    left: 6px;
}

.ck-content {
  margin: 20px auto;
}

.submit-cont .level-verisons {
  margin-bottom: 20px;
  margin-left: -17px;
}
.submit-cont .level-verisons .version-item {
  float: left;
  width: 240px;
  margin-left: 17px;
  max-width: 280px;
  height: 110px;
  text-align: center;
  color: #898989;
  cursor: pointer;
  position: relative;
  padding: 1px;
  background-color: #dfdfdf;
  margin-bottom: 8px;
}
.submit-cont .level-verisons .version-item.active,
.submit-cont .level-verisons .version-item:hover {
  border: none;
  background: #0c368a;
  background: -moz-linear-gradient(left, #0c368a 0, #1b99cf 100%);
  background: -webkit-linear-gradient(left, #0c368a 0, #1b99cf 100%);
  background: -o-linear-gradient(left, #0c368a 0, #1b99cf 100%);
  background: -ms-linear-gradient(left, #0c368a 0, #1b99cf 100%);
  background: linear-gradient(to right, #0c368a 0, #1b99cf 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#0c368a, endColorstr=#1b99cf, GradientType=1);
}
.submit-cont > .ant-row-flex > .ant-col {
  background-color: #fff;
  padding: 25px 20px;
  border-right: 1px solid #ebebeb;
  width: 73%;
}
.submit-cont .level-verisons .version-item .v-name {
  height: 75px;
  line-height: 24px;
  background-color: #fff;
  font-size: 18px;
  padding-top: 15px;
}
.submit-cont .level-verisons .version-item.active .v-name,
.submit-cont .level-verisons .version-item:hover .v-name {
  color: #0c368a;
}
.submit-cont .level-verisons .version-item.active .icon-check,
.submit-cont .level-verisons .version-item:hover .icon-check {
  display: block;
}

.submit-cont .level-verisons .version-item .icon-check {
  display: none;
  position: absolute;
  right: -1px;
  top: -1px;
}
.submit-cont .level-verisons .version-item.active .v-foot,
.submit-cont .level-verisons .version-item:hover .v-foot {
  background-color: transparent;
  color: #fff;
}

.submit-cont .level-verisons .version-item .v-foot {
  height: 33px;
  line-height: 33px;
  background-color: #f5f5f5;
}
.cb-list li {
  line-height: 2;
}
.cb-list .igou {
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 17px;
  margin-top: -4px;
  margin-right: 16px;
  background: url(../assets/images/goucheck.png) no-repeat center;
}
.anticon-slack,
.anticon-heart {
  font-size: 16px;
  margin-right: 11px;
  background-color: #163d8e;
  color: #ffffff;
  border-radius: 50%;
  border: 4px solid #163d8e;
}
.titler {
  font-size: 18px;
  font-weight: 400;
}
.as_list p {
  color: #163d8e;
  margin: 0;
}
.as_list .p2 {
  color: #999;
  font-size: 12px;
  margin-bottom: 20px;
}
.service_div {
  background-color: #0d4f95;
  overflow: hidden;
  padding: 10px;
  color: #ffffff;
  border-radius: 15px 0;
  position: relative;
}

.service_div img{
    width:120px;
}
.service_div p {
  margin: 0;
}

@media screen and (max-width: 1440px) { /*当屏幕尺寸小于xxxpx时，应用下面的CSS样式*/
   .service_div img{
      width:66px;
    }
}
@media screen and (max-width: 700px) {
  .submit-cont .level-verisons .version-item {
    width: 47%;
    margin-left: 2.5%;
  }
}
</style>
